module.exports = __webpack_public_path__ + "static/media/drone.422d1369.svg";